export interface HostAuthContract {
  platformSessionId?: string | null;
  onAuthRequired?: (() => void) | undefined;
}

export interface UserSessionContract {
  session_id?: string | null;
  player_id?: string | number | null;
  guest?: boolean;
}

export function isEmbeddedSessionHost(props: HostAuthContract): boolean {
  return !!props.onAuthRequired;
}

export function isEmbeddedAuthenticatedSession(props: HostAuthContract): boolean {
  return isEmbeddedSessionHost(props) && !!props.platformSessionId;
}

export function isGuestSessionUser(user: UserSessionContract | null | undefined): boolean {
  return !user || user.guest === true || !user.session_id || !user.player_id;
}
